export const baseurly = "https://ppp.kiiramotors.com/api";
export const baseurl = "https://ppp.kiiramotors.com/";
export const baseurl2 = "https://performanceapi.kiiramotors.com/api/ms/employees/";
// export const baseurly = "http://172.16.101.84:4550/api";


// export const API_URL = "http://172.16.101.84:4510/"
// export const API_URL = "https://ppp.kiiramotors.com/"

// export const API_URL = "https://performanceapi.kiiramotors.com/"
export const X_API_KEY = "eLJSzjLXjO0b2fRGRfSkdesjcpvV79wG15PcwHGTiQvKxIe3eUTz+YcHjBFSMMs+jMOZ6H+n3JdFcaffrHzpeak9VFaYwxvf/PAQIxE7CigUmYTeDMQ64lJXmR/D/iffxMRCFxm+mPm/Nei59Tn7eoxaEbqa+wwpox486c8mitbOP8Cg9v9TjyF646GcGMQZW+IcUcx7lwzNqrb8OmXSYwErpamwIpyMSFqCDDgAOVD3vLR4vcLV3FVVS2Q3z0n8yxs23MeLkLGpTIFfFUyK927wgDCmuOkOcVGH5GSyClO2"

// export const PDF_HOST = "https://performanceapi.kiiramotors.com/files/"
export const PDF_HOST = "http://localhost:4500/files/"
 // default baseurl;